export const GET_PLOTS = "GET_PLOTS";
export const GET_PLOT_UPDATE = "GET_PLOT_UPDATE";
export const COPY_PLOT = "COPY_PLOT"